import { singleton } from '@/lib/singleton';

type EventOptions = {
    send_to?: string;
    event_category?: string;
    event_label?: string;
    value?: number;
};
type GoogleAnalytics = {
    readonly push: (...args: any[]) => void;
    readonly event: (name: string, options?: EventOptions) => void;
};

export const GA = singleton<GoogleAnalytics>(() => {
    const gtag = (window as any).gtag;
    const push: (...args: any[]) => void =
        gtag instanceof Function
            ? gtag
            : () => {
                  /* no datalayer, stub out push so everything else still works */
              };

    const event: GoogleAnalytics['event'] = (name, options) => {
        push('event', name, options);
    };

    return {
        push,
        event,
    };
});
